import React, { memo, useEffect } from 'react';

import PlayerContent from './player-content/player-content';
import PlayerDevices from './player-devices/player-devices';
import PlayerLoading from './player-loading/player-loading';
import { Props as PlayerProps } from './types';
import usePlayer from './use-player';
import ErrorDialog from '../error-dialog/error-dialog';
import useError from '@smart-tv/hooks/use-error/use-error';

export const Player = (props: PlayerProps) => {
  const { streamParams, children, className } = props;

  const { errorOpen } = useError();

  const {
    setPlayerNode,
    openPlayerDevices,
    setOpenPlayerDevices,
    playerControls,
    channel,
    setChannel,
    handleReloadStream,
    errorDialogProps
  } = usePlayer(props);

  useEffect(() => {
    document.body.style.setProperty('overflow', 'hidden');
    return () => {
      console.log('closing player, removing body overflow');
      document.body.style.removeProperty('overflow');
    };
  }, []);

  return (
    <div
      className={className}
      onMouseMove={playerControls.handlePlayerMouseMove}
      onMouseLeave={playerControls.handlePlayerMouseLeave}
      onMouseEnter={playerControls.handlePlayerMouseEnter}
    >
      {!errorOpen && (
        <PlayerContent
          channel={channel}
          setPlayerNode={setPlayerNode}
          streamParams={streamParams}
        />
      )}

      <PlayerLoading
        channel={channel}
        setChannel={setChannel}
        mediaId={streamParams?.mediaId}
        eventId={streamParams?.eventId}
      />

      {children}

      <PlayerDevices
        sid={streamParams?.sid}
        open={openPlayerDevices}
        onClose={() => setOpenPlayerDevices(false)}
        onRefreshStream={handleReloadStream}
      />
      {errorDialogProps && (
        <ErrorDialog
          title={errorDialogProps.title}
          message={errorDialogProps.message}
          primaryButton={errorDialogProps.primaryButton}
          secondaryButton={errorDialogProps.secondaryButton}
        />
      )}
    </div>
  );
};

Player.displayName = 'Player';

export default memo(Player);
